export default __webpack_public_path__ + "static/blob6-61a86ece49cc1a8c84189af3a659000a.svg";